import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "../axiosBaseQuery";
import { Occasion, Response } from "../interfaces";

export const occationApi = createApi({
  reducerPath: "occationApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["occasion"],
  endpoints: (builder) => ({
    getOccasionList: builder.query<Response<Occasion[]>, any>({
      query: (credentials) => ({
        url: "occasion/list",
        method: "GET",
        data: credentials,
      }),
      providesTags: ["occasion"],
    }),
    updateOccasion: builder.mutation<Response<Occasion[]>, any>({
      query: (data) => ({
        url: "occasion/" + data.id,
        method: "PATCH",
        data: { name: data?.name },
      }),
      invalidatesTags: ["occasion"],
    }),
    saveOccasion: builder.mutation<Response<Occasion>, any>({
      query: (credentials) => ({
        url: "occasion/create",
        method: "POST",
        data: credentials,
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data: createdPost } = await queryFulfilled;

          // Update the getPosts cache
          dispatch(
            occationApi.util.updateQueryData(
              "getOccasionList",
              undefined,
              (draft) => {
                draft.data.unshift(createdPost.data);
              }
            )
          );
        } catch {
          // Optionally handle errors
        }
      },
    }),
    deleteOccasion: builder.mutation<Response<Occasion[]>, string>({
      query: (credentials) => ({
        url: "occasion/" + credentials,
        method: "DELETE",
      }),
      invalidatesTags: ["occasion"],
    }),
  }),
});

export const {
  useGetOccasionListQuery,
  useSaveOccasionMutation,
  useDeleteOccasionMutation,
  useUpdateOccasionMutation,
} = occationApi;
